import React from 'react';

import 'react-multi-date-picker/styles/backgrounds/bg-dark.css';

import { IOrder } from '@hooks/useCurrentOrder/models';

import { DetailsPanel } from './styles';

import ChangeStatus from './Status';
import ChargesPanel from './Charges';
import UpdatedPayment from './Payment';
import ManualIntegration from './ManualIntegration';

interface IModalProps {
  order: IOrder;
  refetch?: () => Promise<void>;
}

const OrderDetailsPayment: React.FC<IModalProps> = ({ order, refetch }) => {
  const isOrderPending = order?.order.status === 'PENDING';
  return (
    <DetailsPanel>
      <div className="buttonsNav">
        <ChangeStatus order={order.order} />
        <UpdatedPayment order={order} />
        {isOrderPending && (
          <ManualIntegration order={order} refetch={refetch} />
        )}
        <div className="panel">
          <ChargesPanel order={order} />
        </div>
      </div>
    </DetailsPanel>
  );
};

export default OrderDetailsPayment;
